import React, { useState } from "react";
import LoaderContext from "./LoaderContext";

const LoaderState = (props) => {
  const [loaderShow, setLoaderShow] = useState(false);
  return (
    <LoaderContext.Provider
      value={{
        loaderShow,
        setLoaderShow,
      }}
    >
      {props.children}
    </LoaderContext.Provider>
  );
};

export default LoaderState;
